import { useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import EcomEngineAPI from 'api/ecom_engine_api';
import ConfirmPasswordField from 'components/formik/confirm_password_field/confirm_password_field';

export default function SetPassword() {
  const [submissionMessage, setSubmissionMessage] = useState('');

  const onSubmit = ({ newPassword }, { setSubmitting, isSubmitting }) => {
    if (isSubmitting) {
      return;
    }
    setSubmitting(true);
    setSubmissionMessage(null);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = urlParams.get('token');

    EcomEngineAPI.account
      .setPassword({
        password: newPassword,
        token,
      })
      .then((result) => {
        setSubmitting(false);

        if (result.message) {
          setSubmissionMessage(result.message);
        }

        if (result.success) {
          setSubmissionMessage(result.success);
        }
      });
  };

  const formSchema = Yup.object().shape({
    newPassword: Yup.string()
      .required('Password is required')
      .matches(/^.{10,}$/, 'Must contain 10 characters'),
    confirmNewPassword: Yup.string()
      .required('Passwords must match')
      .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
  });

  return (
    <Formik
      initialValues={{
        newPassword: '',
        confirmNewPassword: '',
      }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <div className="row">
          <div className="col-12 col-sm-8 col-lg-5 mx-auto">
            <div className="p-5 my-md-5 bg-white border">
              <h2 className="mb-3">Set a new password</h2>
              {submissionMessage && (
                <div className="alert alert-danger alert-dismissible fade show">
                  {submissionMessage}
                  <button
                    type="button"
                    className="close"
                    onClick={() => setSubmissionMessage(null)}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              )}

              <Form className="needs-validation set-password__form">
                <ConfirmPasswordField
                  passwordName="newPassword"
                  confirmPasswordName="confirmNewPassword"
                />
                <div>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="btn btn-primary mt-4"
                  >
                    {isSubmitting ? (
                      <>
                        <i className="fas fa-spinner-third animation-momentum-spin me-2" />
                        Updating password
                      </>
                    ) : (
                      'Set new password'
                    )}
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )}
    </Formik>
  );
}
